import { setFaroView } from '@/shared/lib';

import { getViewName } from './getViewName';
import { router } from './router';

export const initializeFaroView = () => {
  let lastView = '';

  const applyView = () => {
    const { location, matches } = router.state;
    const view = getViewName(matches, location.pathname);

    if (view === lastView) {
      return;
    }

    lastView = view;
    setFaroView(view);
  };

  applyView();
  // App-lifetime subscription; never unsubscribed by design.
  router.subscribe(applyView);
};
